import { featureToggleSelector } from './featureToggleSelector';
import { IState } from '../../store';

export const selectIsNewbuildingBrokerFlatBannerEnabled = (state: IState) => {
  return featureToggleSelector(state).isNewbuildingBrokerFlatBannerEnabled;
};
